import { useEffect } from 'react';
import { useElementVisibility } from '../../../hooks/useElementVisibility';
import { useI18n } from '../../../i18n/useI18n';
import './ChatSessionListLoadingItem.css';

export type ChatSessionListLoadingItemProps = {
  /** When true, the row observes visibility and calls `onVisible`. */
  enabled: boolean;
  /** When true, shows spinner + loading label (session-row sized). */
  isFetching: boolean;
  onVisible: () => void;
};

export function ChatSessionListLoadingItem({
  enabled,
  isFetching,
  onVisible,
}: ChatSessionListLoadingItemProps) {
  const { translate } = useI18n();
  const { ref, isVisible } = useElementVisibility({
    once: false,
    rootMargin: '80px',
  });

  useEffect(() => {
    if (!enabled || !isVisible) {
      return;
    }
    onVisible();
  }, [enabled, isVisible, onVisible]);

  return (
    <li
      ref={ref}
      className={[
        'liks-chat-session-loading',
        isFetching
          ? 'liks-chat-session-loading--active'
          : 'liks-chat-session-loading--sentinel',
      ].join(' ')}
      aria-busy={isFetching ? true : undefined}
      aria-label={
        isFetching ? translate('chatSessions.loadingMore') : undefined
      }
    >
      {isFetching ? (
        <div className="liks-chat-session-loading__content">
          <span className="liks-chat-session-loading__spinner" aria-hidden />
          <span className="liks-chat-session-loading__label">
            {translate('chatSessions.loadingMore')}
          </span>
        </div>
      ) : null}
    </li>
  );
}
